import React, { useEffect } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { useNavigate, useLocation } from 'react-router-dom'
import { CalmShellPlaceholder } from '../ui/loading'

interface AuthGuardProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function AuthGuard({ children, fallback }: AuthGuardProps) {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!loading && !user) {
      // Store the current location so we can redirect back after login
      const returnTo = location.pathname + location.search
      navigate(`/login?returnTo=${encodeURIComponent(returnTo)}`, {
        replace: true,
      })
    }
  }, [user, loading, navigate, location])

  if (loading) {
    return fallback || <CalmShellPlaceholder variant="app" />
  }

  if (!user) {
    // Show loading while redirecting to login
    return fallback || <CalmShellPlaceholder variant="app" />
  }

  return <>{children}</>
}
